<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_name_cn') || '中文名称'"
            prop="scmCategoryName"
          >
            <el-input
              v-model="formData.scmCategoryName"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_name_en') || '英文名称'"
            prop="scmCategoryEnName"
          >
            <el-input
              v-model="formData.scmCategoryEnName"
              maxlength="50"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_status') || '状态'"
            prop="scmCategoryStatus"
          >
            <el-radio-group
              style="width: 100%;"
              size="small"
              disabled
              v-model="formData.scmCategoryStatus"
            >
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : '--'
              }}
              at {{ formData.createDate ? formData.createDate : '--' }}</span
            >
          </div>
          <div style="font-size: 14px; color: #717171;">
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : '--'
              }}
              at {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      createDataDisabled: false,
      isViewDisabled: false,
      formData: {
        scmCategoryCode: '',
        scmCategoryName: '', // 中文名称
        scmCategoryEnName: '', // 英文名称
        scmCategoryStatus: '', // 有效状态
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: '' // 修改时间
      },
      rules: {
        scmCategoryName: [
          { required: true, message: '请输入中文名称', trigger: 'blur' }
        ],
        scmCategoryEnName: [
          { required: true, message: '请输入英文名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化表单数据
    init() {
      this.isViewDisabled = false
      this.reset()
    },
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = '') {
      this.init()
      if (ref !== 'add') {
        this.createDataDisabled = false
        let param = { scmCategoryCode: val }
        this.$api.scmCategoryDetailApi(param).then((res) => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.createDataDisabled = true
          this.isViewDisabled = true
        }
      } else {
        this.createDataDisabled = false
        this.formData.scmCategoryStatus = 'Y'
      }
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.scmCategorySaveApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success'
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    reset() {
      this.formData = {
        scmCategoryCode: '',
        scmCategoryName: '', // 中文名称
        scmCategoryEnName: '', // 英文名称
        scmCategoryStatus: '', // 有效状态
        createByName: '', // 创建人
        createDate: '', // 创建时间
        modifyByName: '', // 修改人
        modifyDate: '' // 修改时间
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>
